import { createStore } from 'vuex'

export default createStore({
  state: {
    imgId:0,
    imgFile:"",
    rawMatFamily:"",
    rawMatDescription:"",
    develops:[],
  },

  getters: {
    getImgId(state){
      return state.imgId;
    },
    getImgFile(state){
      return state.imgFile;
    },
    getRawMatFamily(state){
      return state.rawMatFamily;
    },
    getRawMatDescription(state){
      return state.rawMatDescription;
    },
    getDevelops(state){
     return state.develops;
    }
  },
  mutations: {
    setImgId (state, id){
      state.imgId= id;
    },
    setImgFile (state,file){
      state.imgFile=file;
    },
    setRawMatFamily(state,name){
      state.rawMatFamily=name;
    },
    setRawMatDescription(state,descrip){
      state.rawMatDescription=descrip;
    },
    addDevelop(state,array){
      state.develops = array;
    },
  },
  actions: {
    setImgIdAction(context , id ){
      context.commit('setImgId',id);
    },
    setImgFileAction(context, file){
      context.commit('setImgFile',file);
    },
    setRawMatFamilyAction(context, file){
      context.commit('setRawMatFamily',file);
    },
    setRawMatDescriptionAction(context, descrip){
      context.commit('setRawMatDescription',descrip);
    },
    addDevelopsAction(context,array){
      context.commit('addDevelop',array)
    }
  },
  modules: {
  }
})
